import * as React from 'react';
import Layout from '../components/Utilities/Layout';
import { Box, Button, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import EntityPermissions from '../components/EntityPermissions';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import PestControlOutlinedIcon from '@mui/icons-material/PestControlOutlined';
import AvTimerOutlinedIcon from '@mui/icons-material/AvTimerOutlined';
import FeatureManager from '../components/Utilities/FeatureManager';

export default class SettingsHome extends React.Component<{}, {}> {
    public render(): React.ReactElement<{}> {
        return (
            <SecurityTrimmer entity={Entity.Configuracion} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                <Layout breadcrumb={
                    [
                        {
                            title: 'Inicio',
                            url: '/'
                        },
                        {
                            title: 'Configuración',
                            url: ''
                        }
                    ]
                }>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <SettingsOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                Configuración
                                </Typography>
                            </Grid>
                            <SecurityTrimmer entity={Entity.Configuracion} permission={PermissionLevel.Administrar}>
                                <Grid item xs={2} className='entitySettings'>
                                    <EntityPermissions entity={Entity.Configuracion}/>
                                </Grid>
                            </SecurityTrimmer>
                        </Grid>
                    </Box>
                    <Box className='main transparent'>
                        <Grid container spacing={3}>
                            <FeatureManager entidad={Entity.Usuarios} operacion='Ver'>
                                <Grid item xs={3}>
                                    <Card square>
                                        <CardContent>
                                            <Stack direction='row' spacing={3} style={{marginBottom: '20px'}}>
                                                <PeopleAltOutlinedIcon style={{fontSize: '42px'}}/>
                                                <Typography variant='h6' gutterBottom textAlign='center' fontWeight={'bold'} style={{position: 'relative', top: '5px'}}>
                                                    Usuarios
                                                </Typography>
                                            </Stack>
                                            <Typography gutterBottom variant="body2" color='text.secondary'>
                                                Agregue, quite o modifique usuarios de AD735 Data Manager
                                            </Typography>
                                            <div style={{textAlign: 'right', marginTop: '20px'}}>
                                                <Button variant='contained' color='info' onClick={() => {
                                                    window.location.href = '/settings/users';
                                                }}>
                                                    Ir
                                                </Button>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </FeatureManager>
                            <FeatureManager entidad={Entity.Permisos} operacion='Administrar'>
                                <Grid item xs={3}>
                                    <Card square>
                                        <CardContent>
                                            <Stack direction='row' spacing={3} style={{marginBottom: '20px'}}>
                                                <SecurityOutlinedIcon style={{fontSize: '42px'}}/>
                                                <Typography variant='h6' gutterBottom textAlign='center' fontWeight={'bold'} style={{position: 'relative', top: '5px'}}>
                                                    Permisos
                                                </Typography>
                                            </Stack>
                                            <Typography gutterBottom variant="body2" color='text.secondary'>
                                                Agregue, quite o modifique permisos a usuarios o grupos de AD735 Data Manager
                                            </Typography>
                                            <div style={{textAlign: 'right', marginTop: '20px'}}>
                                                <Button variant='contained' color='info' onClick={() => {
                                                    window.location.href = '/settings/permisos';
                                                }}>
                                                    Ir
                                                </Button>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </FeatureManager>
                            <FeatureManager entidad={Entity.NivelesPermisos} operacion='Administrar'>
                                <Grid item xs={3}>
                                    <Card square>
                                        <CardContent>
                                            <Stack direction='row' spacing={3} style={{marginBottom: '20px'}}>
                                                <GppGoodOutlinedIcon style={{fontSize: '42px'}}/>
                                                <Typography variant='h6' gutterBottom textAlign='center' fontWeight={'bold'} style={{position: 'relative', top: '5px'}}>
                                                    Niveles de permisos
                                                </Typography>
                                            </Stack>
                                            <Typography gutterBottom variant="body2" color='text.secondary'>
                                                Consulte los niveles de permisos que puede asignar en AD735 Data Manager
                                            </Typography>
                                            <div style={{textAlign: 'right', marginTop: '20px'}}>
                                                <Button variant='contained' color='info' onClick={() => {
                                                    window.location.href = '/settings/nivelespermisos';
                                                }}>
                                                    Ir
                                                </Button>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </FeatureManager>
                            <FeatureManager entidad={Entity.IPS} operacion='Administrar'>
                                <SecurityTrimmer permission={PermissionLevel.SuperAdministrar} entity={Entity.IPS}>
                                    <Grid item xs={3}>
                                        <Card square>
                                            <CardContent>
                                                <Stack direction='row' spacing={3} style={{marginBottom: '20px'}}>
                                                    <LanguageOutlinedIcon style={{fontSize: '42px'}}/>
                                                    <Typography variant='h6' gutterBottom textAlign='center' fontWeight={'bold'} style={{position: 'relative', top: '5px'}}>
                                                        IPS
                                                    </Typography>
                                                </Stack>
                                                <Typography gutterBottom variant="body2" color='text.secondary'>
                                                    Consulte las IPs del sistema o realice una nueva asignación de códigos postales por IP
                                                </Typography>
                                                <div style={{textAlign: 'right', marginTop: '20px'}}>
                                                    <Button variant='contained' color='info' onClick={() => {
                                                        window.location.href = '/settings/ips';
                                                    }}>
                                                        Ir
                                                    </Button>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </SecurityTrimmer>
                            </FeatureManager>
                            <SecurityTrimmer permission={PermissionLevel.SuperAdministrar} entity={Entity.Permisos}>
                                <Grid item xs={3}>
                                    <Card square>
                                        <CardContent>
                                            <Stack direction='row' spacing={3} style={{marginBottom: '20px'}}>
                                                <AvTimerOutlinedIcon style={{fontSize: '42px'}}/>
                                                <Typography variant='h6' gutterBottom textAlign='center' fontWeight={'bold'} style={{position: 'relative', top: '5px'}}>
                                                    Timer Jobs
                                                </Typography>
                                            </Stack>
                                            <Typography gutterBottom variant="body2" color='text.secondary'>
                                                Consulte o gestione los trabajos del temporizador
                                            </Typography>
                                            <div style={{textAlign: 'right', marginTop: '20px'}}>
                                                <Button variant='contained' color='info' onClick={() => {
                                                    window.location.href = '/settings/jobs';
                                                }}>
                                                    Ir
                                                </Button>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </SecurityTrimmer>
                            <Grid item xs={3}>
                                <Card square>
                                    <CardContent>
                                        <Stack direction='row' spacing={3} style={{marginBottom: '20px'}}>
                                            <PestControlOutlinedIcon style={{fontSize: '42px'}}/>
                                            <Typography variant='h6' gutterBottom textAlign='center' fontWeight={'bold'} style={{position: 'relative', top: '5px'}}>
                                                Registro de eventos
                                            </Typography>
                                        </Stack>
                                        <Typography gutterBottom variant="body2" color='text.secondary'>
                                            Consulte los registros de eventos del sistema
                                        </Typography>
                                        <div style={{textAlign: 'right', marginTop: '20px'}}>
                                            <Button variant='contained' color='info' onClick={() => {
                                                window.location.href = '/settings/log';
                                            }}>
                                                Ir
                                            </Button>
                                        </div>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Box>
                </Layout>
            </SecurityTrimmer>
        )
    }
}